import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import FormHistoryLayer from '../components/FormHistoryLayer';

const FormHistoryPage = () => (
  <>
    <MasterLayout pageTitle="Forms Management">
      <FormHistoryLayer />
    </MasterLayout>
  </>
);

export default FormHistoryPage;
